@if (!unCommerceApp && inventoryCheck) {
  <div class="inventory-wrapper">
    @if (!stockLoading) {
      @if (!showQnty) {
        @if (stock > 0) {
          <div class="stock-indication in-stock">
            <span translate>In Stock</span>
          </div>
        }
        @if (stock <= 0) {
          <div class="stock-indication not-in-stock">
            <span translate>Not In Stock</span>
          </div>
        }
      } @else {
        <span>{{stock}}</span>
      }
    } @else {
      <contentloader [showTitle]="false"></contentloader>
    }
  </div>
}
